import { useState } from "react";

import { CheckCompanyExists } from "../CheckCompanyExists";
import { CreateCompanyForm } from "../CreateCompanyForm";

interface Props {
  handleSearchCompanySelected: () => void;
  companyType: "CARRIER" | "SHIPPER";
}

const COMPANY_CONFIG = {
  SHIPPER: {
    companyNamePlaceholder: "My shipper company inc.",
    existingCompanyErrorMessage:
      "A company with the same name already exists. Please ensure your company's info is correct or find and join the company. If you think this is a mistake, please contact us.",
    checkFailedErrorMessage: "Failed to check company name availability",
  },
  CARRIER: {
    companyNamePlaceholder: "My carrier company inc.",
    existingCompanyErrorMessage:
      "A company with the same MC number or the same name already exists. Please ensure your company's info is correct or find and join the company. If you think this is a mistake, please contact us.",
    checkFailedErrorMessage: "Failed to check name and MC number availability",
  },
};

export function CreateCompanyProfile(props: Props) {
  const { handleSearchCompanySelected, companyType } = props;
  const [isCheckingName, setIsCheckingName] = useState<boolean>(true);
  const [companyData, setCompanyData] = useState<{ name: string }>({
    name: "",
  });

  const onCompanyDoesNotAlreadyExist = (companyInfo: {
    name: string;
  }): void => {
    setIsCheckingName(false);
    setCompanyData(companyInfo);
  };

  const handleResetCompanyData = (): void => {
    setCompanyData({ name: "" });
    setIsCheckingName(true);
  };

  const config = COMPANY_CONFIG[companyType];

  if (isCheckingName) {
    return (
      <CheckCompanyExists
        handleSearchCompanySelected={handleSearchCompanySelected}
        onCompanyDoesNotAlreadyExist={onCompanyDoesNotAlreadyExist}
        companyNamePlaceholder={config.companyNamePlaceholder}
        existingCompanyErrorMessage={config.existingCompanyErrorMessage}
        checkFailedErrorMessage={config.checkFailedErrorMessage}
      />
    );
  }
  return (
    <CreateCompanyForm
      companyData={companyData}
      handleSearchCompanySelected={handleSearchCompanySelected}
      handleResetCompanyData={handleResetCompanyData}
      companyType={companyType}
    />
  );
}
